<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="服务商" label-width="80px">
        <el-select v-model="queryParam.agentSn" clearable filterable remote :remote-method="getAgents" :loading="loading" placeholder="输入服务商名称搜索">
          <el-option v-for="agent in agents" :key="agent.sn" :label="agent.companyName" :value="agent.sn"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" label-width="80px">
        <el-input v-model="queryParam.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="时间" label-width="80px">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态" label-width="80px">
        <el-radio v-model="queryParam.status" label="0">全部</el-radio>
        <el-radio v-model="queryParam.status" label="1">已发放</el-radio>
        <el-radio v-model="queryParam.status" label="2">未发放</el-radio>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>佣金列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <el-button type="primary" @click="exportData()">
              导出
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="commissions" border>
      <el-table-column prop="date" label="结算日期" width="100"></el-table-column>
      <el-table-column prop="companyName" label="服务商名称"></el-table-column>
      <el-table-column prop="name" label="姓名" width="80"></el-table-column>
      <el-table-column label="佣金" width="180">
        <template #default="scope">
          <span :class="scope.row.completed ? 'color_success' : 'color_warning'">￥{{scope.row.amount}}</span>
          <el-link type="primary" href="javascript:;" style="margin-left: 12px;" v-if="scope.row.completed && scope.row.pic" @click="showPic(scope.row.pic)">转账单</el-link>
        </template>
      </el-table-column>
      <el-table-column label="明细">
        <template #default="scope">
          <el-row :gutter="8" v-for="(item, index) in scope.row.commissionBillItemVOS" :key="index">
            <el-col :span="14">{{item.factoryName}}</el-col>
            <el-col :span="6">{{item.registerDate}}</el-col>
            <el-col :span="4">￥{{item.amount}}</el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" :disabled="scope.row.completed" @click="showSend(scope.row)">确认发放</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog title="确认发放" v-model="sendVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="sendForm">
      <el-form-item label="转账单" label-width="88px">
        <el-upload class="image_uploader" :action="apiBase + 'api/v1/common/upload/image/commission_payed'" :show-file-list="false"
                   :on-success="handleSuccess" :before-upload="beforeUpload">
          <img v-if="sendParam.pic" :src="$utils.imageSrc(sendParam.pic)"/>
          <el-icon v-else class="uploader_icon"><plus /></el-icon>
        </el-upload>
      </el-form-item>
      <el-button type="primary" @click="confirm">确认</el-button>
    </el-form>
  </el-dialog>

  <el-image-viewer v-if="showViewer" @close="closeViewer" :url-list="viewerUrls" />
</template>

<script>
export default {
  name: "门店开发佣金",
  props: {
    currentUser: Object
  },
  data() {
    return {
      apiBase: process.env.VUE_APP_API_BASE,
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {
        status: '0'
      },
      dateRange: null,
      commissions: [],
      loading: false,
      agents: [],
      sendVisible: false,
      sendParam: {},
      showViewer: false,
      viewerUrls: []
    }
  },
  methods: {
    beforeUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLes5M = file.size / 1024 / 1024 < 5
      if (!isImg) {
        this.$message.error('图片只能是 JPG 格式!')
      }
      if (!isLes5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isImg && isLes5M
    },
    handleSuccess(res, file) {
      this.sendParam.pic = res.data
    },
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      if (this.dateRange) {
        this.queryParam.startDate = this.dateRange[0]
        this.queryParam.endDate = this.dateRange[1]
      } else {
        this.queryParam.startDate = null
        this.queryParam.endDate = null
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.shopCommission.list(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        this.commissions = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showSend(commission) {
      this.sendParam = {
        sn: commission.sn,
        date: commission.date,
        name: commission.name
      }
      this.sendVisible = true
    },
    confirm() {
      if (!this.sendParam.pic) {
        this.$message.error('请上传转账单')
        return
      }
      this.$confirm('确认 ' + this.sendParam.date + '【' + this.sendParam.name + '】的佣金已发放？', '确认发放',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        const param = {
          sn: this.sendParam.sn,
          pic: this.sendParam.pic
        }
        this.$apis.shopCommission.confirmSend(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.sendVisible = false
            this.list()
          }
        })
      }).catch(() => {

      })
    },
    showPic(pic) {
      this.viewerUrls = [this.$utils.imageSrc(pic)]
      this.showViewer = true
    },
    closeViewer() {
      this.showViewer = false
    },
    exportData() {
      this.$apis.shopCommission.exportData(this.queryParam).then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            window.open(response.data)
          }, 1500)
        }
      })
    },
    getAgents(str) {
      if (str !== '') {
        this.loading = true
        this.$apis.agentMgr.list(0, 15, {companyName: str}).then(response => {
          this.agents = response.data.data
          this.loading = false
        })
      } else {
        this.agents = []
      }
    }
  },
  created() {
    this.list()
  }
}
</script>

<style scoped>

</style>